import api from 'common/api'

export type Sender = {
  LatestReceivedDate: string
  LatestTitle: string
  MessageType: string
  Scid: number
  SenderCity?: string
  SenderCountry?: string
  SenderName: string
  SenderState?: string
  Total: number
  UnreadCount: number
}

const getMyMatchesSenders = () => api.get<Sender[]>('/api/message-center?creation_source=myMatches')

const myMatchesSendersService = {
  getMyMatchesSenders,
}

export default myMatchesSendersService
